<template>
  <div v-show="desc" :class="['product-description', { clamped: isClamped }]">
    <!-- eslint-disable vue/no-v-html -->
    <div ref="content" class="product-description__content"></div>

    <div class="clamp"></div>

    <div v-if="isClampable" class="product-description__btn-wrapper">
      <button
        class="product-description__expand-contract"
        @click="isClamped = !isClamped"
        v-html="isClamped ? $t('clamp.read-more') : $t('clamp.read-less')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDescription',
  props: {
    /** Product description */
    desc: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isClamped: null,
      isClampable: null,
      maxContentHeight: 130,
    }
  },
  watch: {
    isClamped(newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.$refs.content.scrollIntoView({ behavior: 'smooth' })
      }
    },
  },
  mounted() {
    this.initializeClamp()
    this.setDesc()
  },
  methods: {
    setDesc() {
      const desc = document.querySelector('.product-description__content')

      if (desc) desc.innerHTML = this.format(this.desc)
    },
    initializeClamp() {
      this.isClampable = this.isOverMaxContentHeight()
      this.isClamped = this.isClampable
    },
    /** convert line breaks to p html tag */
    format(string) {
      return (string || '')
        .replace(/(.*?)\r?\n\r?\n/g, '<p>$1</p>')
        .replace(/\r\n/g, '<br/>')
        .replace(/\n/g, '<br/>')
    },
    isOverMaxContentHeight() {
      const element = this.$refs.content
      if (element && element.scrollHeight > this.maxContentHeight) {
        return true
      }

      return false
    },
  },
}
</script>

<style scoped lang="scss">
$clampHeight: 130px;

.product-description {
  .clamp {
    display: none;
  }

  &.clamped {
    position: relative;

    .product-description__content {
      max-height: $clampHeight;
      overflow: hidden;
    }

    .clamp {
      display: block;
      position: absolute;
      top: 0;
      width: 100%;
      height: $clampHeight;
      z-index: 1;

      background: linear-gradient(0deg, #f4f9fd, rgba(255, 255, 255, 0) 100%);
    }
  }

  .product-description__btn-wrapper {
    margin-top: 10px;
    text-align: center;
  }

  .product-description__expand-contract {
    background-color: transparent;
    padding: 5px 10px;
    border: 1px solid $v4_color_line_darker;
    border-radius: 4px;
    color: $v4_color_text;
    text-transform: uppercase;
    font-size: 11px;
    cursor: pointer;
    transition: background-color 100ms ease-in-out;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }

    &:focus {
      background-color: transparent;
      outline: 0;
    }
  }

  @media (min-width: $v4_desktop) {
    &.clamped {
      .clamp {
        background: linear-gradient(0deg, #f4f9fd, rgba(253, 247, 250, 0) 100%);
      }
    }
  }
}
</style>
